export function mailingToggle() {
  console.log("mailingToggle");

  let toggle = document.getElementById("mailing-toggle"),
    mailingElement = document.getElementById("mc_embed_signup"),
    mailingForm = document.getElementById("mailing-form");

  toggle.addEventListener("click", function () {
    console.log("toggle on click");
    if (this.classList.contains("on")) {
      closeMailingForm(this);
    } else {
      openMailingForm(this);
    }
  });

  function openMailingForm(toggleElement) {
    // add the class
    toggleElement.classList.add("on");
    mailingForm.classList.add("mailinglist-open");

    window.scrollTo(0, document.body.scrollHeight);
  }

  function closeMailingForm(toggleElement) {
    // remove the class
    toggleElement.classList.remove("on");
    mailingForm.classList.remove("mailinglist-open");
  }

  console.log("mailingToggle function done");
} // export default function init()
